import service from '@/request/service';
//登录
export function loginIn(data) {
  return service({
    url: '/user/login',
    method: 'post',
    data,
  });
}

// 多角色登录
export function loginRole(data) {
  return service({
    url: '/user/updateLoginUserType' + '/' + data.token + '/' + data.type,
    method: 'post',
  });
}

// 开标情况记录
export function openBidjl(data) {
  return service({
    url: '/record/updateOpenRecordOne',
    method: 'post',
    data,
  });
}
// 查询开标情况其他事项
export function getOpenBidjl(data) {
  return service({
    url: '/record/selectOpenRecord',
    method: 'post',
    data,
  });
}

export function genRandom() {
  return service({
    url: '/user/ca/genRandom',
    method: 'get',
  });
}

// ca登录
export function loginByCA(data) {
  return service({
    url: '/user/ca/login',
    method: 'post',
    data,
  });
}

//单点登录
export function loginInBySSO(url,data) {
  return service({
    url: url,
    method: 'post',
    data,
  });
}

// 退出登录
export function loginOut() {
  return service({
    url: '/user/logout',
    method: 'post',
  });
}

// 获取左侧菜单(无阶段)
// export function getMenuListNoStage(data) {
//   return http({
//     url: '/openProject/getOpenBidSectionByBidSectionIdNoStage',
//     method: 'post',
//     data
//   });
// }

// 获取左侧菜单(多阶段)
// export function getMenuListManyStage(data) {
//   return http({
//     url: '/openProject/getOpenBidSectionByBidSectionId',
//     method: 'post',
//     data
//   });
// }

// 获取左侧菜单新
export function getMenuList(params) {
  return service({
    url: '/project/openReady/getMenuList',
    method: 'get',
    params: params,
  });
}

// 获取服务器时间
// export function getSystemDate() {
//   return service({
//     url: '/project/openReady/getServerDate',
//     method: 'post'
//   });
// }

// 用户信息
// export function getOnlineUser() {
//   return http({
//     url: '/user/getOnlineUser',
//     method: 'post'
//   });
// }

// 加载二维码
export function applyQrCode() {
  return service({
    url: '/ebidsun/applyQrCode',
    method: 'post',
  });
}

// 检验二维码
export function queryQrStatus(qrCode) {
  return service({
    url: '/ebidsun/queryQrStatus?qrCode=' + qrCode,
    method: 'post',
  });
}

// 二维码登录
export function sunLogin(data) {
  return service({
    url: '/ebidsun/login',
    method: 'post',
    data,
  });
}

// 根据标段id获取开标信息
export function getOpenBidBySectionId(data) {
  return service({
    url: '/project/openRecord/getOpenBidBySectionId',
    method: 'post',
    data,
  });
}

// 根据开标id获取开标信息
export function getOpenBidByOpenbidId(data) {
  return service({
    url: '/project/openbidOther/getOpenBidByOpenbidId',
    method: 'post',
    data,
  });
}

// 标前会存储
export function savePreBidMeeting(data) {
  return service({
    url: '/pre/savePreBidMeeting',
    method: 'post',
    data,
  });
}
// 标前会查询
export function selectPreBidMeeting(data) {
  return service({
    url: '/pre/selectPreBidMeeting',
    method: 'post',
    data,
  });
}

// 获取是否同步投标人完成
// export function getSyncBidderState(data) {
//   return http({
//     url: '/project/openReady/getSyncBidderState',
//     method: 'post',
//     data
//   });
// }

// 获取投标人点击标志
// export function getPubBidderButtonState(data) {
//   return http({
//     url: '/project/openReady/getPubBidderButtonState',
//     method: 'post',
//     data
//   });
// }

// 保存投标人点击信息
// export function setPubBidderButtonState(data) {
//   return http({
//     url: '/project/openReady/setPubBidderButtonState',
//     method: 'post',
//     data
//   });
// }

// 获取服务器时间
export function getCurrentServerDateTime() {
  return service({
    url: '/tools/getCurrentServerDate',
    method: 'get',
  });
}

// 更新状态
export function updateOpenbidStateShow() {
  return service({
    url: '/openBid/info/update/opening',
    method: 'post',
  });
}

// 统一表格头配置
export function findPageTemplate(data) {
  return service({
    url: '/pageTemplate/findPageTemplate',
    method: 'post',
    data,
  });
}

// 二阶段过度页面状态
export function getOpenBidState(data) {
  return service({
    url:
      '/openBid/info/getOpenBidState/' +
      data.domainId +
      '/' +
      data.bidSectionId +
      '/' +
      data.openBidId,
    method: 'get',
  });
}

// 跳转地址
export function getJumpUrl(params) {
  return service({
    url: '/project/openReady/getJumpUrl',
    method: 'post',
    data: params,
  });
}

// 是否显示验证码
export function hasCode(params) {
  return service({
    url: '/user/hasCode',
    method: 'get',
    params,
  });
}

// 流标是否小于等于三家
export function getBidSectionIsNeedFailBid(params) {
  return service({
    url: '/failBid/getBidSectionIsNeedFailBid',
    method: 'post',
    data: params,
  });
}

// 批量流标
export function batchFailBid(params) {
  return service({
    url: '/failBid/batchFailBid',
    method: 'post',
    data: params,
  });
}

// 开标结果签章文件上传
export function uploadSignFile(params) {
  return service({
    url: '/report/uploadSignOpenReportFile',
    method: 'post',
    data: params,
  });
}

// 开标结果签章标识上传
export function signOpenReportFile(params) {
  return service({
    url: '/report/signOpenReportFile',
    method: 'post',
    data: params,
  });
}
// 开标结果签章标识上传
export function getOpenExcelFile(params) {
  return service({
    url: '/report/getOpenExcelFile',
    method: 'post',
    data: params,
  });
}

// 磋商签章文件上传
export function signUploadFile(params) {
  return service({
    url: '/open/inquiry/uploadSignFile',
    method: 'post',
    data: params,
  });
}

// 磋商签章标识上传
export function signSignature(params) {
  return service({
    url: '/open/inquiry/bidder/signature',
    method: 'post',
    data: params,
  });
}


// 获取待签章招标文件 浙江CA接口
export function getFileSignInfo(params) {
  return service({
    url: '/signatureZJCAExt/getFileSignInfo',
    method: 'post',
    data: params,
  });

}

// 浙江CA签章保存接口
export function saveSignFile(params) {
  return service({
    url: '/signatureZJCAExt/saveSignFile',
    method: 'post',
    data: params,
  });
}

// 汇信CA签章 - 获取appid
export function hxGetUserInfo(params) {
  return service({
    url: '/HXsignature/getUserInfo',
    method: 'post',
    data: params,
  });
}
  
// 汇信CA签章 - 检测签章是否完成
export function hxCheckFileIsSign(params) {
  return service({
    url: '/HXsignature/checkFileIsSign',
    method: 'post',
    data: params,
  });
}

export function getQuestionEnterUrl(data) {
  return service({
    url: '/question/getEnterUrl',
    method: 'post',
    data,
  });
}
